import { createSlice } from '@reduxjs/toolkit';
import axios from 'components/Axios';
import {
  getbusinessCategory,
  getCategory,
  getCountry,
  getjobType,
  getPostCategory,
  getReportReasons,
  getworkType,
} from 'redux/APIEndPoint';

export const DropdownSlice = createSlice({
  name: 'dropdown',
  initialState: {
    categoryList: [],
    jobList: [],
    workTypeList: [],
    countryList: [],
    postCategoryList: [],
    businessCategory: [],
    reportReasons: [],
  },
  reducers: {
    category: (state, action) => {
      const dropdownItem = [];
      action?.payload?.forEach((data) => {
        dropdownItem.push({ value: data.id, label: data.category });
      });
      state.categoryList = dropdownItem;
    },
    jobType: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.type,
          value: data.id,
        });
      });
      state.jobList = dropdownItem;
    },
    workType: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.type,
          value: data.id,
        });
      });
      state.workTypeList = dropdownItem;
    },
    country: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.name,
          value: data.abbr,
        });
      });
      state.countryList = dropdownItem;
    },
    postCategory: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.category,
          value: data.id,
        });
      });
      state.postCategoryList = dropdownItem;
    },
    BusinessCategory: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.category,
          value: data.id,
        });
      });
      state.businessCategory = dropdownItem;
    },
    reportReasons: (state, action) => {
      const dropdownItem = [];
      action?.payload.forEach((data) => {
        dropdownItem.push({
          label: data.reasons,
          value: data.id,
        });
      });
      state.reportReasons = dropdownItem;
    },
  },
});

export const getCategoryList = () => async (dispatch) => {
  try {
    const response = await axios.get(getCategory);
    dispatch(category(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getJobTypeList = () => async (dispatch) => {
  try {
    const response = await axios.get(getjobType);
    dispatch(jobType(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getWorkTypeList = () => async (dispatch) => {
  try {
    const response = await axios.get(getworkType);
    dispatch(workType(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getCountryList = () => async (dispatch) => {
  try {
    const response = await axios.get(getCountry);
    dispatch(country(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getPostCategoryList = () => async (dispatch) => {
  try {
    const response = await axios.get(getPostCategory);
    dispatch(postCategory(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getBusinessCategoryList = () => async (dispatch) => {
  try {
    const response = await axios.get(getbusinessCategory);
    dispatch(BusinessCategory(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const getReportListByType = (type) => async (dispatch) => {
  try {
    const response = await axios.get(getReportReasons + `?type=${type}`);
    dispatch(reportReasons(response.data));
  } catch (err) {
    throw new Error(err);
  }
};

export const {
  category,
  jobType,
  workType,
  country,
  postCategory,
  BusinessCategory,
  reportReasons,
} = DropdownSlice.actions;
export default DropdownSlice.reducer;
